import React from 'react'
import MaskedInput from 'react-text-mask';

function detectmob() { 
  if( navigator.userAgent.match(/Android/i)
  || navigator.userAgent.match(/webOS/i)
  || navigator.userAgent.match(/iPhone/i)
  || navigator.userAgent.match(/iPad/i)
  || navigator.userAgent.match(/iPod/i)
  || navigator.userAgent.match(/BlackBerry/i)
  || navigator.userAgent.match(/Windows Phone/i)
  ){
     return true;
   }
  else {
     return false;
   }
 }

class HourInput extends React.Component{
  render(){
    let mask = [/[0-2]/,/[0-9]/,':',/[0-5]/,/[0-9]/];
    if(this.props.value.split(":")[0][0] == "2")
      mask = [/[0-2]/,/[0-3]/,':',/[0-5]/,/[0-9]/];
    return(
      <div style={this.props.divStyle}>
        { detectmob() ?
          <input {...this.props} value={this.props.value} type="time"/>
        :
        <MaskedInput {...this.props}
            value={this.props.value} 
            mask={mask} 
            />
        }  
      </div>
    )
  }
}

export default HourInput;



// WEBPACK FOOTER //
// ./src/inputs/HourInput.js